import { EditorController } from '@ibiz-template/runtime';
import { IArray } from '@ibiz/model-core';

/**
 * 数组编辑器控制器
 * @return {*}
 * @author: zhujiamin
 * @Date: 2022-08-25 10:57:58
 */
export class ArrayEditorController extends EditorController<IArray> {}
